export default {
  route: {
    routeHome: 'Home',
    routeVehicle: 'Vehicle Information',
    routeRepair: 'Maintenance Information',
    routeTechnical: 'Technical Documents',
    routeCircuit: 'Circuit Diagram',
    routeSystemOverview: 'System Overview',
    routeMaintenance: 'Maintenance',
    routeSearchParts: 'Parts Query',
    routePartsAdvice: 'Parts Consulting',
    routePartsAdviceDetails: 'Details of accessory consultation',
    routePartsAdviceList: 'Parts Consulting Management List',
    routeResolvedManagement: 'List of resolved issues',
    routeFeedBack: 'Problem Feedback',
    routeSysProFeedBack: 'Feedback List',
    routeMaintainFeedBack: 'Maintenance Case Feedback',
    routeSysFeedBack: 'Feedback Management List',
    routeCart: 'Shopping Cart',
    routeIccId: 'ICCID查询',
    routeKeyQuery: 'Keycode Query',
    routeQueryStatistics: 'Query Statistics',
    routeOrder: 'Orders',
    routeSysUser: 'User Management',
    routeSysRole: 'Role Management',
    routeSysMenu: 'Menu Permission Management',
    routeSysEnterprise: 'Enterprise Information Management',
    routeSysChange: 'Change Management',
    routeSystem: 'System Management',
    routeInfo: 'Information Feedback',
    operation: 'Vehicle Information',
    userManual: 'Owner Manual',
    maintenance: 'Maintenance & Warranty',
    version: 'Diagnostic software version',
    disassembly: 'Dismantling Manual',
    emergency: 'Emergency Rescue',
    routeItp: 'ITP—Intelligent Technology Information Platform',
    routeReleaseManagement: 'Release Management',
    routePublicAnnouncement: 'Public Announcement',
    routeKnowledge: 'Knowledge',
    routeMarketDisposal: 'Market Disposal',
    routeTechnicalCircular: 'Technical Circular',
    routeVehBom: 'One BOM per car',
    routeVehCar: 'Vehicle configuration table',
    routeSpareParts: 'Spare Parts Splitting',
    routeCriticalParts: 'Quality critical parts',
    routeLoginManagement: 'Login information management',
    routeLoadBom: 'Overseas Data Rights Management',
    routeLanguage: 'Language Management',
    routeVehicleNavigation: 'Vehicle Model Navigation Management',
    routeOverseasData: 'Overseas Data Rights Management',
    routeOverseas: 'Overseas Management',
    routeSubscriptionRightsManagement: '订阅权限管理',
    routeSparePartsAnnouncement: '备件公告',
    routeFeedbackOnQualityIssues: '技术质量问题反馈',
    routeFeedbackOnQualityIssuesList: '技术质量问题反馈管理列表',
    routeFeedbackOnQualityIssuesDetails: '技术质量问题反馈详情',
    routeAboutUs: 'About Us'
  },
  documentTypes: {
    wis: 'Repair manual',
    circuit_diagram: 'Wiring diagram',
    overview: 'System overview & Maintenance',
    maintenance: '保修保养',
    c3d_atlas: '配件图册',
    user_manual: '用户手册',
    warranty_manual: '保养手册'
  },
  common: {
    commonDelete: 'Delete',
    commonCancel: 'Cancel',
    commonConfirm: 'OK',
    commonSearch: 'Search',
    commonUpload: 'Upload',
    commonClose: 'Close',
    commonPreserve: 'Save',
    commonDelTips: 'Delete Prompt',
    commonTips: 'Are you sure you want to delete',
    commonCopy: 'Copy VIN',
    common1: 'Enable',
    common2: 'Disable',
    common3: 'Lock',
    common4: 'No data',
    common5: 'Release',
    common6: 'Undo Publishing',
    common7: 'Modify',
    common8: 'More Searches'
  },
  searchHome: {
    vehicle: 'Vehicle Model Navigation',
    parts: 'Parts',
    tips: 'Please select search terms',
    tips2: 'Please enter',
    tips3: 'Please enter a 17-digit VIN code',
    tips4: 'Please enter the part name or part code',
    time: 'Last login time',
    notice: 'Announcement',
    more: 'More',
    market: 'Market information',
    update: 'Data update',
    maintenance: 'Maintenance Cases',
    access: 'Access History',
    accessory: 'Parts Consulting',
    part1: 'Parts code',
    part2: 'Part',
    part3: 'System',
    part4: 'Supplier code',
    part5: 'Supplier name',
    part6: 'Vehicle materials',
    part7: 'Date of manufacture',
    part8: 'Part number',
    part9: 'Hierarchical relationship',
    part10: 'User name',
    part11: 'Login time'
  },
  login: {
    title: 'Welcome to Login',
    logIn: 'Log In',
    logOut: 'Log Out',
    username: 'Account',
    password: 'Reset your password',
    userLogIn: 'Username and Password',
    cepLogin: 'Login with CEP account',
    mobileLogIn: 'LDAP',
    thirdparty: 'Third Party Login'
  },

  table: {
    model: 'Vehicle Models',
    faulty: 'Malfunction System',
    theme: 'Subject',
    date: 'Time',
    title: 'Title',
    importance: 'Importance',
    type: 'Type',
    remark: 'Comment',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    id: 'Num',
    status: 'Status',
    actions: 'Operation',
    edit: 'Edit',
    reset: 'Reset',
    delete: 'Delete'
  },
  cart: {
    viewOrder: 'View Order',
    generateOrder: 'Create Order',
    sendOrder: 'Submit Order',
    partCode: 'Part Code',
    partName: 'Part Name',
    pcsOrder: 'Order Quantity',
    minimum: 'Minimum Packaging Quantity',
    shoppingNum: 'Order No. of Cart List',
    orderDate: 'Order Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    startTime: 'Start Time',
    endTime: 'End Time'
  },
  maintainFeedBack: {
    myFeedback: 'My Feedback',
    feedbackManage: 'Feedback Management List'
  },
  partsAdvice: {
    hide: 'Hide',
    show: 'Show',
    question: 'My Questions',
    askQuestion: 'I want to ask questions',
    partsManagement: 'Accessory consulting management',
    feedbackOnQualityIssuesManagement: '技术质量问题反馈管理列表',
    resolvedManagement: 'List of resolved issues',
    myProblem: 'My Problems',
    storeName: 'Service Center Name',
    enterpriseName: '企业名称',
    storeCode: 'Service Center Code',
    enterpriseCode: '企业代码',
    station: 'Post',
    name: 'Name',
    userName: '用户名',
    problemType: 'Problem Type',
    problemDes: 'Problem Description',
    problemStatus: 'Problem Status',
    date: 'Date',
    submitTime: 'Submission Time',
    storeInfo: 'Service Center Information',
    modelInfo: 'Vehicle Model Information',
    consultQuestion: 'Consult Questions',
    resolve: 'Resolved Causes',
    setResolved: 'Set to Resolved',
    resolvedReason: 'Confirm that the issue has been resolved ?',
    tips: 'Prompt',
    answer: 'Answer Record',
    questionReply: 'Question Reply',
    reply: 'Reply',
    replyTime: 'Replier Time',
    respondent: 'Replier',
    issueLevel: 'Issue level',
    responseTime: 'Response Time'
  },
  repair: {
    state: 'Release status',
    model: 'Vehicle type',
    year: 'Model Year',
    config: 'Configuration',
    mileage: 'Range',
    powerBattery: 'Battery',
    faultLocation: 'Faulty system',
    faultyPart: 'Malfunction Parts',
    submitter: 'Maintenance Technician',
    contactPhone: 'Contact Number',
    eMailAddress: '邮箱地址',
    subject: 'Malfunction Subject',
    enterpriseName: 'Leapmotor Service Center',
    dtcInfo: 'DTC Information',
    controller: 'Controller',
    faultDesc: 'Malfunction Description',
    language: 'Language',
    repair1: 'Reviewer',
    repair2: 'Audit time',
    repair3: 'Review comments',
    repair4: 'Audit status',
    repair5: 'Integral',
    repair6: 'Examine'
  },
  problemFeedBack: {
    classify: 'Problem Classification',
    systematic: 'Affiliated System'
  },
  system: {
    userType: 'User Type',
    roleName: 'Role Name',
    state: 'Status',
    keyWord: 'All',
    searchValue: 'Please enter keywords to search',
    settingRole: 'Role Permission Settings'
  },
  keyQuery: {
    queryStatistics: 'Query Statistics',
    searchUsers: 'Search Users',
    repair: 'Service Center',
    queryTime: 'Query Time',
    vinCode: 'VIN Code',
    keyCode: 'Keycode'
  },
  routeVehicle: {
    materialCode: 'Material Code',
    logisticsDes: 'Logistics Description',
    vehicleSeries: 'Basic Vehicle Series',
    basicModel: 'Basic Vehicle Model',
    basicYear: 'Basic Model Year',
    range: 'Range',
    optionalPower: 'Optional Power',
    hub: 'Hub',
    exterior: 'Exterior Style',
    roof: 'Roof Style',
    interior: 'Interior Style',
    package: 'Optional Package',
    battery: 'Battery Cell',
    vehicle1: 'Year Type',
    vehicle2: 'Optional Range',
    vehicle3: 'Optional Hub',
    vehicle4: 'Car number',
    vehicle5: 'Vehicle attributes',
    vehicle6: 'Announced model',
    vehicle7: 'Engine number',
    vehicle8: 'Motorcycle type',
    vehicle9: 'Battery model',
    vehicle10: 'Battery serial number',
    vehicle11: 'Engine model',
    vehicle12: 'Motor serial number',
    vehicle13: 'Certificate No',
    vehicle14: 'Motor model',
    vehicle15: 'Vehicle origin',
    vehicle16: 'Vehicle name',
    vehicle17: 'Serial number of electric drive (front)',
    vehicle18: 'Serial number of electric drive (rear)',
    vehicle19: 'Common name of vehicle',
    vehicle20: 'Manufacturing plant',
    vehicle21: 'Vehicle brand',
    vehicle22: 'Exterior color',
    vehicle23: 'Name of vehicle manufacturer',
    vehicle24: 'Vehicle type',
    vehicle25: 'Fuel type',
    vehicle26: 'Vehicle sales change time',
    vehicle27: 'Date of manufacture',
    vehicle28: 'VDC warehousing date',
    vehicle29: 'Vehicle delivery time',
    vehicle30: 'Sales date',
    vehicle31: 'Real name status',
    vehicle32: 'Acceptance time',
    vehicle33: 'Vehicle configuration table',
    vehicle34: 'Type name',
    vehicle35: 'Illustrate',
    vehicle36: 'Vehicle configuration',
    vehicle37: 'Original filename',
    vehicle38: 'Advanced search'
  },
  routeSearchParts: {
    searchParts1: 'Part Drawing No.',
    searchParts2: 'Part Name',
    searchParts3: 'Father Part Drawing No.',
    searchParts4: 'Quantity',
    searchParts5: 'Object Picture',
    searchParts6: 'Man Hour Code',
    searchParts7: 'Man Hour',
    searchParts8: 'Disassembly steps',
    searchParts9: 'Tools',
    searchParts10: 'Affiliated System Code',
    searchParts11: 'Affiliated System Name',
    searchParts12: 'Vehicle Model',
    searchParts13: 'Loading Quantity',
    searchParts14: 'Remark',
    searchParts15: 'Vehicle Models',
    searchParts16: 'Model Year',
    searchParts17: 'Configuration',
    searchParts18: 'Package Type',
    searchParts19: 'Battery',
    searchParts20: 'Range',
    searchParts21: 'Type approval number',
    searchParts22: 'Variant',
    searchParts23: 'Version',
    searchParts24: 'Maintenance items',
    searchParts25: 'Name of subsystem',
    searchParts26: 'Single vehicle consumption',
    searchParts27: 'Historical loading amount',
    searchParts28: 'Parent part number',
    searchParts29: 'Parent part name',
    searchParts30: 'Interchangeable',
    searchParts31: 'Details',
    searchParts32: 'Add to cart',
    searchParts33: 'Whether it can be sold',
    searchParts34: 'Applicable models'
  },
  technical: {
    technical1: 'System overview',
    technical2: 'Maintenance tools',
    technical3: 'System working principle',
    technical4: 'Location of system components',
    technical5: 'Fault diagnosis',
    technical6: 'Special tools',
    technical7: 'Common faults',
    technical8: 'Maintenance guidance',
    technical9: 'Man hour station',
    technical10: 'Matters needing attention',
    technical11: 'Technical parameter',
    technical12: 'Serial Number',
    technical13: 'Directory name',
    technical14: 'Configuration information',
    technical15: 'Look Up',
    technical16: 'Name',
    technical17: 'Album name',
    technical18: 'Atlas version',
    technical19: 'Config',
    technical20: 'Effect time',
    technical21: 'Invalid time',
    technical22: 'No atlas',
    technical23: 'Disassembly and assembly steps',
    technical24: 'Sub working hours'
  },
  routeRepair: {
    routeRepair1: 'Parts Catalogue',
    routeRepair2: 'Service Manual',
    routeRepair3: 'Parts Detail',
    routeRepair4: 'Part Code',
    routeRepair5: 'Price',
    routeRepair6: 'Part Name',
    routeRepair7: 'Inventory',
    routeRepair8: 'Minimum Packaging Quantity',
    routeRepair9: 'Total Inventory',
    routeRepair10: 'Purchase',
    routeRepair11: 'Alternative Relationship',
    routeRepair12: 'P/N before Change',
    routeRepair13: 'P/N after Change',
    routeRepair14: 'Alternative Type',
    routeRepair15: 'Breakpoint Time',
    routeRepair16: 'Breakpoint VIN',
    routeRepair17: 'Replacement Remark',
    routeRepair18: 'Quality critical parts',
    routeRepair19: 'SBOM attribute notes',
    routeRepair20: 'Second track information',
    routeRepair21: 'Configuration string compatibility description (including left and right rudder)',
    routeRepair22: 'Technical conditions'
  },
  routeCircuit: {
    routeCircuit1: 'Circuit Diagram Information',
    routeCircuit2: 'Circuit Diagram Introduction',
    routeCircuit3: 'Fuses & Relays',
    routeCircuit4: 'Power Distribution',
    routeCircuit5: '接地点分配',
    routeCircuit6: '线束布置图',
    routeCircuit7: '接插件端子定义',
    routeCircuit8: '对插件位置图',
    routeCircuit9: '对接插件',
    routeCircuit10: '线束结构图',
    routeCircuit11: '接地位置图',
    routeCircuit12: 'Full screen browsing'
  },
  sysUserList: {
    buildType: 'User Type',
    enterpriseType: 'Enterprise information',
    roleName: 'Role',
    code: 'Account',
    state: 'Status',
    job: 'Post',
    userName: 'Username',
    sex: 'Gender',
    phone: 'Phone Number'
  },
  sysRole: {
    routeSysRole1: 'Role Name',
    routeSysRole2: 'Role Code',
    routeSysRole3: 'Service Center Code',
    routeSysRole4: 'Role Remark',
    routeSysRole5: 'Tel/Email',
    routeSysRole6: 'Creation Time',
    routeSysRole7: 'Validity Period',
    routeSysRole8: '状态',
    routeSysRole9: 'Modify System Roles'
  },
  sysMenu: {
    routeSysMenu1: 'Fold/Unfold',
    routeSysMenu2: 'Menu Name',
    routeSysMenu3: 'Menu Type',
    routeSysMenu4: 'Menu Code',
    routeSysMenu5: 'Menu Path',
    routeSysMenu6: 'Sorting',
    routeSysMenu7: 'Menu Icon',
    routeSysMenu8: 'Father Menu'
  },
  sysEnterprise: {
    sysEnterprise1: 'Enterprise Type',
    sysEnterprise2: 'Brand',
    sysEnterprise3: 'Enterprise Code',
    sysEnterprise4: 'Enterprise Name',
    sysEnterprise5: 'Enterprise Address',
    sysEnterprise6: 'Contact Name',
    sysEnterprise7: 'Contact Number',
    sysEnterprise8: 'Contact E-mail',
    sysEnterprise9: 'Modification Time',
    sysEnterprise10: 'Modified By',
    sysEnterprise11: 'Area Type',
    sysEnterprise12: 'After-sales Service Area',
    sysEnterprise13: 'Please select an area',
    sysEnterprise14: 'Province',
    sysEnterprise15: 'City',
    sysEnterprise16: 'Distribution Brand',
    sysEnterprise17: '创建时间'
  },
  sysChange: {
    sysChange1: 'Vehicle Models',
    sysChange2: 'Change the ECN/EWO Name',
    sysChange3: 'EWO Name',
    sysChange4: 'Switchover Mode',
    sysChange5: 'Change Issuance Time',
    sysChange6: 'Change Receiving Time',
    sysChange7: 'Change SPA or not',
    sysChange8: 'On-site Implementation',
    sysChange9: 'Pre-assembly or not',
    sysChange10: 'Pre-assembly Conclusion',
    sysChange11: 'Change Stage',
    sysChange12: 'Received the switchover result or not',
    sysChange13: 'MWO Number',
    sysChange14: 'MWO Effective Date',
    sysChange15: 'Breakpoint VIN Code'
  },
  notice: {
    notice1: 'Model',
    notice2: 'Module grouping',
    notice3: 'Part Name',
    notice4: 'Content',
    notice5: 'More',
    notice6: 'System',
    notice7: 'Main cause parts',
    notice8: 'Fault phenomenon',
    notice9: 'Possible causes',
    notice10: 'Activity type',
    notice11: 'Activity No',
    notice12: 'Activity Name',
    notice13: 'Unlock content',
    notice15: 'Notice',
    notice16: 'Data',
    notice17: 'Release time',
    notice18: 'Publisher',
    notice19: 'Subsystem',
    notice20: 'Date Created',
    notice21: 'Created By',
    notice22: 'Vehicle Code',
    notice23: 'Part No',
    notice24: 'Factory',
    notice25: 'Usage',
    notice26: '电池一车一BOM',
    notice27: '车辆VIN',
    notice28: '编码',
    notice29: '类别',
    notice30: '电驱BOM',
    notice31: 'SN码',
    notice32: '物料号',
    notice33: '物料名',
    notice34: '工单号',
    notice35: 'BOM物料号',
    notice36: 'BOM物料名',
    notice37: '关联控制器SN',
    notice38: '关联控制器物料号',
    notice39: '关联控制器物料名',
    notice40: '控制器工单号',
    notice41: '发送时间',
    notice42: '发送人',
    notice43: '发送信息'
  },
  overseas: {
    overseas1: 'Organization code',
    overseas2: 'Organization name',
    overseas3: 'Overseas authority',
    overseas4: 'Whether VIN can be viewed',
    overseas5: 'Chinese name',
    overseas6: 'Translated or not',
    overseas7: 'English name',
    overseas8: '推送模块',
    overseas9: '详细信息',
    overseas10: '邮箱',
    overseas11: '下载模版',
    overseas12: '保存失败',
    overseas13: '需保留最后一条数据',
    overseas14: '备件公告1',
    overseas15: '知识库',
    overseas16: '市场处置',
    overseas17: '技术通告',
    overseas18: '维修案例',
    overseas19: '新增邮箱'

  },
  iccId: {
    IoTNetworkCardICCID: '物联网卡ICCID',
    updateTime: 'updateTime'
  },
  zip: {
    export: 'Export',
    import: 'Import',
    uploadAttach: 'Upload Attachment',
    enclosure: 'Attachment',
    enclosure1: 'Audit attachments',
    placeholder: 'Please enter the file name (default file)',
    success: 'Submitted successfully',
    update: 'Modified successfully',
    add: 'New information',
    modify: 'Modify information',
    details: 'View details',
    required: 'There are still required items not filled in'
  },
  message: {
    selectVehicleType: 'Please select vehicle type',
    selectTypeApprovalNumber: 'Please select type certification number',
    selectVersion: 'Please select version',
    syncSuccess: 'Synchronization is successful',
    selectPartDrawingOrPartName: 'Please enter part drawing number or part name',
    selectVehYearModel: 'Please choose annual payment',
    selectOptRange: 'Please select mileage',
    selectOptPower: 'Please select Configuration',
    selectBatteryCore: 'Please select the battery type',
    selectType: 'Please select the type',
    noSyncAgainFor5Minutes: "Can't sync again for 5 minutes",
    browserCanNotWork: 'you browser can not work',
    switchSizeSuccess: 'Switch Size Success',
    compilingTheTheme: 'Compiling the theme',
    copySuccessfully: 'Copy successfully',
    copyFailed: 'Copy failed',
    orderGenerated: 'Order generated',
    selectOrderWantToGenerated: 'Select the order you want to generate',
    successfullyDelete: 'delete successful',
    enterYourVIN: 'Please enter the vin number',
    length17: '17 characters long',
    enterSubject: 'Please enter a subject',
    enterProblemDescription: 'Please enter the problem description',
    enterPersonAskingTheQuestion: 'Please enter the person asking the question',
    enterContactPhone: 'Please enter a contact number',
    wrongNumber: 'The format of the phone number is wrong',
    uploadAttachment: 'Please upload the attachment.',
    uploadSuccess: 'upload successful',
    orderGeneratedSuccess: 'Order generated successfully',
    selectOrderToSend: 'Select the order you want to send',
    replySuccess: 'Reply successful',
    fillInSolutionReason: 'Please fill in the solution reason',
    selectCarSeries: 'Please select the car series',
    selectQuestionCategory: 'Please select the question category',
    selectGroup: 'Please select group',
    enterQueryTime: 'Please enter the query time',
    addedToCart: 'Added to cart',
    selectQueryCriteria: 'Please select your query criteria',
    published: 'Have published!',
    selectPublish: 'Please select content to publish',
    cancelRelease: 'Cancel release!',
    selectContent: 'Please select Undo content',
    operateSuccess: 'operate successfully',
    selectNeedToDelete: 'Select what you want to delete',
    successfullyAdded: 'successfully added',
    selectSystem: 'Please select your system',
    selectVINOrVehicleNavigation: 'Select VIN query or vehicle navigation query',
    canceled: 'canceled',
    mustBeNumericValue: 'Must be a numeric value',
    queryNumber: 'Please enter the query number',
    regionCode: 'Please enter the region code',
    regionName: 'Please enter a region name',
    provinceOrMunicipalityCode: 'Please select input province/municipality code',
    provinceOrMunicipality: 'Please select input province/municipality',
    cityCode: 'Please select the city code',
    city: 'Please select the input city',
    areaInformationDetails: 'Area Information Details',
    newAreaInformation: 'New area information',
    modifyingRegionInformation: 'Modifying region information',
    enterpriseInformationSuccessfully: 'Save enterprise information successfully',
    modifiedRegionInformationSuccessfully: 'Modified region information successfully',
    companyName: 'Please enter a company name',
    companyCode: 'Please enter the enterprise number',
    length11: 'It is 11 characters long',
    companyType: 'Please select a business type',
    selectState: 'Please select status',
    length100: '100 characters long',
    newCompany: 'New enterprise information',
    updateCompany: 'Modifying enterprise information',
    saveSystemUserSuccessfully: 'Save system user successfully',
    updateCompanySuccess: 'Modify enterprise success',
    menuName: 'Please enter a menu name',
    menuCode: 'Please enter the menu code',
    menuUrl: 'Please enter the menu path',
    menuType: 'Please select a menu type',
    length2To10: 'Between 2 and 10 characters in length',
    length4To50: 'Between 4 and 50 characters in length',
    length4To100: 'Between 4 and 100 characters in length',
    menuDetail: 'System Menu Details',
    addMenu: 'Add System menu',
    updateMenu: 'Modify the system menu',
    saveMenuSuccess: 'Save system menu successfully',
    updateMenuSuccess: 'Modified system menu successfully',
    saveSuccess: 'save successfully',
    enterRoleName: 'Please enter a role name',
    enterRoleCode: 'Please enter the role code',
    length4To20: 'Between 4 and 20 characters in length',
    newRole: 'New system roles',
    updateRole: 'Modifying system roles',
    saveRoleSuccess: 'Save system role successfully',
    updateRoleSuccess: 'Modified system role successfully',
    uploadError: 'Upload error',
    selectFile: 'Please select file',
    uploadedAvatarSuccess: 'Uploaded avatar successfully',
    resetPasswordSuccess: 'Reset password successfully',
    enterAccount: 'Please enter your user account',
    enterUserName: 'Please enter a user name',
    selectCompany: 'Please select Enterprise',
    selectRole: 'Please select a role',
    selectPosition: 'Please select a position',
    userDetail: 'System User details',
    addUser: 'New system user',
    updateUser: 'Modifying the system user',
    updateUserSuccess: 'Modified system user successfully',
    undeleted: 'Undeleted',
    selectAttachments: 'Please select attachments',
    pleaseSubscribe: 'Please subscribe to view!',
    checkMemberError: 'Failed to check member status'
  }

}
